module.exports = __webpack_public_path__ + "static/media/netflixGeeked.42d00ed9.png";